import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Icon } from '../components/Icon'
import { BRAND } from '../brand'

const LABELS: Record<string, string> = {
  '': 'Dashboard',
  transactions: 'Transactions',
  accounts: 'Accounts',
  gateways: 'Gateways',
  audit: 'Audit log',
  users: 'Users & roles',
  roles: 'Roles & permissions',
  config: 'System config',
  account: 'My account',
}

export function ContextBar() {
  const { pathname } = useLocation()
  const nav = useNavigate()
  const parts = pathname.split('/').filter(Boolean)
  const crumbs = [{ label: BRAND.name, to: '/' }, ...parts.map((p, i) => ({ label: LABELS[p] ?? p, to: '/' + parts.slice(0, i + 1).join('/') }))]

  // Live "updated Xs ago" freshness indicator (resets on route change / manual refresh).
  const [secs, setSecs] = useState(0)
  useEffect(() => {
    setSecs(0)
    const t = setInterval(() => setSecs((s) => s + 1), 1000)
    return () => clearInterval(t)
  }, [pathname])

  return (
    <div className="ctxbar">
      {crumbs.map((c, i) => (
        <span key={c.to} style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
          {i > 0 && (
            <span className="sep">
              <Icon name="chevR" size={13} />
            </span>
          )}
          <span className="crumb" onClick={() => nav(c.to)}>
            {c.label}
          </span>
        </span>
      ))}
      <span className="ts">
        <span style={{ display: 'inline-block', width: 6, height: 6, borderRadius: '50%', background: 'var(--success)', marginRight: 6 }} />
        updated {secs}s ago
      </span>
    </div>
  )
}
